export default [
  {
    path: '/applicant/offers/',
    name: 'applicant-offers',
    meta: { is_paginatable: true, isPositionOffers: true },
    component: () =>
        import(/* webpackChunkName: "applicant" */ '@/components/applicants/offers/Offers.vue')
  },
  {
    path: '/applicant/questions/',
    name: 'applicant-questions',
    component: () =>
        import(/* webpackChunkName: "applicant" */ '@/components/applicants/questions/Questions.vue')
  },
  {
    path: '/applicant/history-companies/',
    name: 'applicant-history-companies',
    component: () =>
        import(/* webpackChunkName: "applicant" */ '@/components/applicants/history_companies/HistoryCompanies.vue')
  },
  {
    path: '/applicant/languages/',
    name: 'applicant-languages',
    component: () =>
        import(/* webpackChunkName: "applicant" */ '@/components/applicants/languages/Languages.vue')
  },
  {
    path: '/applicant/educations/',
    name: 'applicant-educations',
    component: () =>
        import(/* webpackChunkName: "applicant" */ '@/components/applicants/educations/Educations.vue')
  },
  {
    path: '/applicant/texts/',
    name: 'applicant-texts',
    component: () =>
        import(/* webpackChunkName: "applicant" */ '@/components/applicants/texts/Texts.vue')
  },
  {
    path: '/applicant/locations/',
    name: 'applicant-locations',
    component: () =>
        import(/* webpackChunkName: "applicant" */ '@/components/applicants/locations/Locations.vue')
  },
  {
    path: '/applicant/meetings/',
    name: 'applicant-meetings',
    component: () =>
        import(/* webpackChunkName: "applicant" */ '@/components/applicants/meetings/Meetings.vue')
  }
]
